import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';

export const EditionButton = ({ passive, deniedServices, viewportMode, onEditMode, handleEnterEdition }) => {
    const isEditionDenied = deniedServices.includes('showEdition');
    const isAllowEditionDenied = deniedServices.includes('allowEdition');
    const isComparativeMode = viewportMode === 'comparative';
    const isEditionDisabled = passive || isEditionDenied || isAllowEditionDenied || isComparativeMode;

    const isCurrentlyEditing = onEditMode;

    return (
        <button
            id="editionButton"
            className={`edition-btn hide-mobile${isCurrentlyEditing ? ' edition-disabled' : ''}`}
            onClick={handleEnterEdition}
            disabled={isEditionDisabled || isCurrentlyEditing}
        >
            {ihm_viewer__dictionary.EDITION_MODE[locale()]}
        </button>
    );
};
